module.exports = __webpack_public_path__ + "static/img/khsk.54542c43.png";